<ion-header class="header --underline --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="routes.reports" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>Reports</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="report">
  <div class="wrapper">
    <div class="report__detail">
      <div class="report__detail__results">
        <div class="report__detail__results__total">
          <span class="report__detail__results__total__title" [innerHTML]="'Umsatz gesamt'"></span>
          <span class="report__detail__results__total__amount" [innerHTML]="'19.123 €'"></span>
          <span class="report__detail__results__total__average" [innerHTML]="'Average 955 €'"></span>
        </div>
        <div class="report__detail__results__last-month --up">
          <span class="report__detail__results__last-month__emote">😀</span>
          <span class="report__detail__results__last-month__amount">30% <ion-icon name="arrow-up-outline"></ion-icon></span>
          <span class="report__detail__results__last-month__text">Than last month</span>
        </div>
      </div>
      <div class="report__detail__graph"></div>
      <div class="report__detail__slider__wrapper">
        <span class="report__detail__slider__arrow --left" (click)="prevSlide()"><ion-icon name="chevron-back-outline"></ion-icon></span>
        <ion-slides class="report__detail__slider" id="mySlider" [options]="{ slidesPerView: 'auto', spaceBetween: 0}">
          <ion-slide class="report__detail__slider__item">ago</ion-slide>
          <ion-slide class="report__detail__slider__item">sept</ion-slide>
          <ion-slide class="report__detail__slider__item">oct</ion-slide>
          <ion-slide class="report__detail__slider__item">nov</ion-slide>
          <ion-slide class="report__detail__slider__item">dic</ion-slide>
          <ion-slide class="report__detail__slider__item">ene</ion-slide>
          <ion-slide class="report__detail__slider__item">feb</ion-slide>
          <ion-slide class="report__detail__slider__item">mar</ion-slide>
          <ion-slide class="report__detail__slider__item">apr</ion-slide>
          <ion-slide class="report__detail__slider__item">may</ion-slide>
          <ion-slide class="report__detail__slider__item">jun</ion-slide>
          <ion-slide class="report__detail__slider__item">jul</ion-slide>
        </ion-slides>
        <span class="report__detail__slider__arrow --right" (click)="nextSlide()"
          ><ion-icon name="chevron-forward-outline"></ion-icon
        ></span>
      </div>
    </div>
    <div class="report__ranking">
      <span class="report__ranking__title" [innerHTML]="'Ranking'"></span>
      <ion-list class="report__ranking__list">
        <ion-item *ngFor="let item of ranking" class="report__ranking__list__item">
          <img src="/assets/avatar/anna.svg" alt="" class="report__ranking__list__item__avatar" />
          <div class="report__ranking__list__item__content">
            <span class="report__ranking__list__item__content__number">#<span [innerHTML]="item.rank"></span></span>
            <span class="report__ranking__list__item__content__name" [innerHTML]="item.name"></span>
          </div>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>
